import { createActions, handleActions } from 'redux-actions';
import { createSelector } from 'reselect';

import * as loadingStates from '@coconut/constants/loadingState';

export const types = {
  FETCH_PROFILE: 'FETCH_PROFILE',
  FETCH_PROFILE_SUCCESS: 'FETCH_PROFILE_SUCCESS',
  FETCH_PROFILE_FAILED: 'FETCH_PROFILE_FAILED',
  CLEAN_PROFILE: 'CLEAN_PROFILE',
};

export const {
  fetchProfile,
  fetchProfileSuccess,
  fetchProfileFailed,
  cleanProfile,
} = createActions(
  {
    [types.FETCH_PROFILE_SUCCESS]: (profile) => ({ profile }),
    [types.FETCH_PROFILE_FAILED]: (errorMessage) => ({ errorMessage }),
  },
  types.FETCH_PROFILE,
  types.CLEAN_PROFILE
);

const INIT_STATE = {
  loadingStatus: loadingStates.EMPTY,
  data: {},
};

const reducer = handleActions(
  {
    [types.FETCH_PROFILE]: (state) => ({
      ...state,
      loadingStatus: loadingStates.LOADING,
    }),
    [types.FETCH_PROFILE_SUCCESS]: (state, action) => ({
      loadingStatus: loadingStates.READY,
      data: action.payload.profile,
    }),
    [types.FETCH_PROFILE_FAILED]: (state, action) => ({
      ...state,
      loadingStatus: loadingStates.ERROR,
      errorMessage: action.payload.errorMessage,
    }),
    [types.CLEAN_PROFILE]: (state) => ({
      ...state,
      ...INIT_STATE,
    }),
  },
  INIT_STATE
);

export default reducer;

export const getUserProfile = (state) => state.profile.data;
export const getUserId = createSelector(getUserProfile, (data) => data.userId);
export const getFirstName = createSelector(
  getUserProfile,
  (data) => data.firstName
);
export const getLastName = createSelector(
  getUserProfile,
  (data) => data.lastName
);
export const getUsername = createSelector(
  getUserProfile,
  (data) => data.username
);
export const getEmail = createSelector(getUserProfile, (data) => data.email);
export const getCountryCode = createSelector(
  getUserProfile,
  (data) => data.countryCode
);
export const getRole = createSelector(getUserProfile, (data) => data.role);

export const getRoleStatus = createSelector(
  getUserProfile,
  (data) => data.roleStatus
);

export const getAvatar = createSelector(getUserProfile, (data) => data.avatar);
export const getIsProfileCompleted = createSelector(
  getUserProfile,
  (data) => data.isProfileCompleted
);
export const getProfileCompletionMessage = createSelector(
  getUserProfile,
  (data) => data.profileCompletionMessage
);

export const getRegion = createSelector(getUserProfile, (data) => data.region);



// WEBPACK FOOTER //
// ./src/services/redux/profile.js